const CRMPropertyFieldTypes = {
  BOOLEAN_CHECKBOX: 'booleancheckbox',
  CALCULATION_EQUATION: 'calculation_equation',
  CALCULATION_READ_TIME: 'calculation_read_time',
  CALCULATION_ROLLUP: 'calculation_rollup',
  CALCULATION_SCORE: 'calculation_score',
  CHECKBOX: 'checkbox',
  DATE: 'date',
  FILE: 'file',
  HTML: 'html',
  NUMBER: 'number',
  PHONE_NUMBER: 'phonenumber',
  RADIO: 'radio',
  SELECT: 'select',
  /**
   * TODO ZS 8/11: this is a temporary fix for the
   * CRM not properly validating fieldTypes. It
   * should be removed once validation is in place.
   */
  STRING: 'string',
  TEXT: 'text',
  TEXTAREA: 'textarea',
  UNKNOWN: 'unknown'
};
export default CRMPropertyFieldTypes;